<h4 class="title-bg">Datos de la agencia</h4>
<div class="col-md-12 col-6 align-self-center align-self-lg-center mb-4 mb-lg-0 mt-5">
    <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
        <img src="../assets/images/body/icons/volver.svg" class="pe-2" alt="">
        <p class="mb-0 back"> Volver</p>
    </a>
</div>

<div *ngIf="agencia != null" class="d-flex align-items-baseline mt-4">
    <h2>{{agencia.nombre}}</h2>
    <p class="info">Información de la agencia</p>
</div>

<form *ngIf="agencia != null" action="" class="login mt-4">
    <div class="row">
        <div class="col-md-6 col-12">
            <div class="form-control">
                <h5 class="mb-2">Nombre de la agencia</h5>
                <input disabled type="text" name="nombre" class="w-100" [(ngModel)]="agencia.nombre">
            </div>
            <div class="form-control">
                <h5 class="mb-2">Nombre del vendedor</h5>
                <input disabled type="text" name="vendedor" class="w-100" [(ngModel)]="agencia.vendedor">
            </div>
            <div class="form-control">
                <h5 class="mb-2">Dirección</h5>
                <input disabled type="text" name="direccion"  class="w-100" [(ngModel)]="agencia.direccion">
            </div>
            <div class="form-control">
                <h5 class="mb-2">Correo Electrónico</h5>
                <input disabled type="email" name="email" class="w-100" [(ngModel)]="agencia.email">
            </div>
            <div class="form-control">
                <h5 class="mb-2">Teléfono</h5>
                <input disabled type="text" name="telefono"  class="w-100" [(ngModel)]="agencia.telefono">
            </div>
            <div class="form-control">
                <h5 class="mb-2">Razón Social</h5>
                <input disabled type="text" name="razonSocial"  class="w-100" [(ngModel)]="agencia.razonSocial">
            </div>
        </div>
        <div class="col-md-6 col-12">
            <div style="height: 250px;" class="pd-b">
                <h5 class="mb-2">Foto de perfil</h5>
                <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" 
                style="margin-left: 5px; margin-bottom: 0px;">
                    <img *ngIf="!existImg" src="../assets/images/body/tours/01.jpg" class="h-100" alt="" >
                    <img *ngIf="existImg" [src]="domSrv.bypassSecurityTrustUrl(imagen)" alt="" style="width: 100%;">
                </div>
            </div>
            <div >
                <h5 class="pd-b mb-2">Redes sociales</h5>
            </div>
            <div class="pd-b d-flex align-items-center flex-row" >
                <img src="../assets/images/body/icons/twitter.svg" class="pe-3" alt="">
                <input disabled type="text" name="twitter" class="w-100" [(ngModel)]="agencia.twitter">
            </div>
            <div class="pd-b d-flex align-items-center flex-row" >
                <img src="../assets/images/body/icons/facebook.svg" class="pe-3" alt="">
                <input disabled type="text" name="facebook" class="w-100" [(ngModel)]="agencia.facebook">
            </div>
            <div class="pd-b d-flex align-items-center flex-row" >
                <img src="../assets/images/body/icons/instagram.svg" class="pe-3" alt="">
                <input disabled type="text" name="instagram" class="w-100" [(ngModel)]="agencia.instagram">
            </div>
        </div>
    </div>
</form>

